import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ChatStoreEffects } from './effects';
import { chatReducer } from './reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('chat', chatReducer),
    EffectsModule.forFeature([ChatStoreEffects])
  ]
})
export class ChatStoreModule {} 